export const getLanguages = (languages = [], currentLocale) => {
    const productionEnabledLocales = process.env.REACT_APP_PRODUCTION_ENABLED_LOCALES || '';
    const currentSiteIsLive = productionEnabledLocales.indexOf(currentLocale) !== -1;

    if (!currentSiteIsLive) {
        return languages;
    }

    return languages.filter((item) => productionEnabledLocales.indexOf(item.locale) !== -1);
};

export const formatDomain = (uri) => {
    if (uri.lastIndexOf('/') === uri.length - 1) {
        return uri.slice(0, uri.length - 1);
    }

    return uri;
};

export const getGenericLink = (locale, languages) => {
    let uri;
    uri = languages?.find((i) => i.locale === locale)?.uri;

    if (!uri) {
        return '';
    }

    if (uri?.toLowerCase().indexOf('//') === 0) {
        uri = `https:${uri}`;
    }
    return uri;
};

export const getLinkWithSlug = (locale, hreflangs, languages) => {
    let uri;
    const formattedLocale = locale.split('_').join('').toLowerCase();
    const localeExistsAsHref = hreflangs.some((i) => i.locale === locale || i.locale === formattedLocale);

    if (!localeExistsAsHref || (languages && languages.locale === locale)) {
        uri = getGenericLink(locale, languages);
    } else {
        const language = hreflangs.find((i) => i.locale === locale || i.locale === formattedLocale);

        uri = language.uri;

        if (!uri) {
            return '';
        }
        if (uri.toLowerCase().indexOf('//') === 0) {
            uri = `https:${uri}`;
        }
    }

    return uri;
};

export const getHreflangs = (localeAlternates, languages = []) => {
    if (!localeAlternates) {
        return null;
    }

    return localeAlternates
        .map((item) => {
            let language;
            if (item.applicationId) {
                language = languages.find((language) => language.id === item.applicationId);
            } else {
                const itemLocale = item.locale?.split('_')?.[1];
                language = languages.find((l) => l.locale.substr(0, 2) === itemLocale.substr(0, 2));
            }

            if (!language) {
                return null;
            }

            return {
                ...item,
                id: item.externalId,
                locale: language.locale,
                uri: `${formatDomain(language.uri)}${item.slug}`,
            };
        })
        .filter((i) => i);
};
